// src/functions/portalProfileApi.js
// Portal-client self-service profile (name/email/phone). Backs the Profile
// Information section on ClientPortalSettings.js. Endpoints: GET/PUT
// /api/clients/me, added in backend/routes/client_router.py.

import { apiAxios } from "./axiosInstance";

const unwrap = (error, fallback) => {
  if (error.response?.data) {
    throw new Error(error.response.data.detail || fallback);
  }
  throw new Error(error.message || fallback);
};

// GET /api/clients/me
// Response: { name, email, phone }
export const getMyProfile = async () => {
  try {
    const response = await apiAxios.get("/clients/me");
    return response.data;
  } catch (error) {
    return unwrap(error, "Failed to fetch profile");
  }
};

// PUT /api/clients/me
// Request: { name?, email?, phone? } — Response: { name, email, phone }
export const updateMyProfile = async (updates) => {
  try {
    const response = await apiAxios.put("/clients/me", updates);
    return response.data;
  } catch (error) {
    return unwrap(error, "Failed to update profile");
  }
};
